import { useSelector, useDispatch } from 'react-redux';
import { selectSelectedComponent, updateComponent } from '../../../redux/editorSlice';
import { PaddingControl, BorderRadiusControl, StyleControl } from '../CommonProperties';



const BenefitSummaryProperties = () => {
  const selectedComponent = useSelector(selectSelectedComponent);
  const dispatch = useDispatch();

  return (
    <>
      
    </>
  );
};

export default BenefitSummaryProperties;
